/* 
   Function that takes a string and breaks it into separate strings 
   no bigger than 'maxWidth', with breaks made at complete words.
   'maxWidth' is a number of characters.

   Example : splitLabel("I am Superman", 4) => ["I am", "Superman"]
*/
export function splitLabel(label: string, maxWidth: number): string[] {
  const labelSections: string[] = []
  const words = label.split(' ')
  let temp = ''

  words.forEach(function (item: string, index: number) {
    if (temp.length > 0) {
      const concat = temp + ' ' + item

      if (concat.length > maxWidth) {
        labelSections.push(temp)
        temp = ''
      } else {
        if (index == words.length - 1) {
          labelSections.push(concat)
          return
        } else {
          temp = concat
          return
        }
      }
    }

    if (index == words.length - 1) {
      labelSections.push(item)
      return
    }

    if (item.length < maxWidth) {
      temp = item
    } else {
      labelSections.push(item)
    }
  })

  return labelSections
}

/* 
   Function that takes a string and replaces the portion after the character 
   specified by `maxWidth` by "..." (ellipsis).

   Example : truncateLabel("I am Superman", 4) => "I am..."
*/
export function truncateLabel(label: string, maxWidth: number): string {
  if (label.length <= maxWidth) {
    return label
  }
  const truncatedLabel = label.slice(0, maxWidth).trim()
  const truncatedLabelWithEllipsis = truncatedLabel + '\u2026'
  return truncatedLabelWithEllipsis
}
